import { useMutation, useQuery, useQueryClient, keepPreviousData } from '@tanstack/react-query';
import type { ApiResponse } from '@/shared/api';
import type { ApiResponseList } from '@/shared/api/types';
import { KASSA_KEYS } from '../lib';
import { KassaApi } from '../api';
import type { KassaAcceptPayload, KassaItem, KassaListParams } from './types';

export const useKassaList = (params?: KassaListParams) => {
  return useQuery<ApiResponseList<KassaItem>>({
    queryKey: KASSA_KEYS.list(params),
    queryFn: () => KassaApi.getList(params),
    placeholderData: keepPreviousData,
    staleTime: 0,
    refetchOnMount: 'always',
  });
};

export const useAcceptKassa = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: KassaAcceptPayload) => KassaApi.accept(payload),
    onSuccess: async (response: ApiResponse<null>) => {
      if (response.success) {
        await queryClient.invalidateQueries({ queryKey: KASSA_KEYS.all, refetchType: 'active' });
      }
    },
  });
};
